import { Validator } from "../validator"

// Invalid conditions requested by ntuc
// Mobile No. does not begin with "8" or "9"
// Mobile No. begins with '800' or 99'
// Mobile number starting with 999 or 995
// Mobile Number equals '90000000'
// Mobile Number equals '88888888'

enum MobileNumberError {
    PATTERN = `errors.invalid_phone_number`,
}

const PATTERN = /^[689]\d{7}$/ // exactly 8 digits, starting with 6/8/9. No 'g' flag.
const INVALID_START = [`800`, `99`, `999`, `995`]
const INVALID_NUMBER = [`88888888`, `90000000`] // keep explicit bans if required by business

class MobileNumberValidator implements Validator<string, MobileNumberError> {
    validate(value: string): MobileNumberError | undefined {
    // Ensure exact 8 digits starting with 6, 8, or 9
        if (!PATTERN.test(value)) {
            return MobileNumberError.PATTERN
        }

        // Disallow prefixes 800, 99, 999, 995
        if (INVALID_START.some(prefix => value.startsWith(prefix))) {
            return MobileNumberError.PATTERN
        }

        // Disallow all-same-digit numbers: 00000000, 11111111, ...
        if (/^(\d)\1{7}$/.test(value)) {
            return MobileNumberError.PATTERN
        }

        // Keep any explicit forbidden numbers
        if (INVALID_NUMBER.includes(value)) {
            return MobileNumberError.PATTERN
        }

        return undefined
    }
}

export default MobileNumberValidator
export { MobileNumberError }
